import { Stack } from "@mui/material";
import userService from "../../api/UserService";
import { useAppRoutes } from "../../routes/index";
import { boxHeight } from "../../styles/consts";
import { useLayoutConfig } from "../context/LayoutConfigProvider";
import { useNavbarOffer } from "../context/NavbarOfferContext";
import UserProvider from "../context/UserProvider";
import useData from "../hooks/useData";
import { User } from "../models/Models";
import { FullStack } from "../styles/Box.styles";
import ErrorBoundary from "./ErrorBoundary";
import Navbar from "./layout/Navbar";
import PrimarySidebar from "./layout/PrimarySidebar";
import SecondarySidebar from "./layout/SecondarySidebar";

export default function LoggedInView() {
  const { data: user } = useData<User>(userService.getUser);
  const { layoutConfig } = useLayoutConfig();
  const routes = useAppRoutes();
  const { offerData } = useNavbarOffer();

  return user ? (
    <UserProvider initialUser={user}>
      <ErrorBoundary showBackButton={true}>
        <Navbar
          offerTitle={offerData?.title}
          offerCompanyName={offerData?.companyName}
          offerUrl={offerData?.url}
          isArchived={offerData?.isArchived}
        />

        <Stack
          sx={{
            flexDirection: "row",
            width: "100%",
            height: `calc(100% - ${boxHeight})`,
            minHeight: `calc(100% - ${boxHeight})`,
            maxHeight: `calc(100% - ${boxHeight})`,
          }}
        >
          <PrimarySidebar />
          {layoutConfig.secondarySidebarVisible && <SecondarySidebar />}
          <FullStack
            sx={{
              overflowY: "auto",
              overflowX: "hidden",
            }}
          >
            {routes}
          </FullStack>
        </Stack>
      </ErrorBoundary>
    </UserProvider>
  ) : (
    <></>
  );
}
